import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as IconEstate } from '../icons/estate.svg';
import MapButton from './MapButton';
import { createStyles, makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => createStyles({
    iconEstate: {
        fill: theme.palette.text.secondary,
    },
}));
const FitStandsBoundsButton = (props) => {
    const { className, setPositionLock, fitBoundsToStands } = props;
    const onClick = () => {
        setPositionLock(false);
        fitBoundsToStands();
    };
    const classes = useStyles();
    return (React.createElement(MapButton, { className: className },
        React.createElement(IconButton, { color: 'inherit', onClick: onClick },
            React.createElement(IconEstate, { className: classes.iconEstate }))));
};
export default FitStandsBoundsButton;
